import { copySourceReadBehaviors } from '../../constants/read-behavior-constants';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { isTridentInIframe } from '../../shared/utils/iframe.utils';
import { IAttribute } from '../base/annotation';
import { Metamodel } from '../base/model';
import { SalesforceDataset } from '../dataset/salesforce.dataset';
import { ModelConstants } from '../model-constants';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: ModelConstants.salesforceCopySource,
    disabled: isTridentInIframe(),
    display: [],
    tags: { datasetModel: Metamodel.modelFor(SalesforceDataset) }
})
export class SalesforceCopySource extends TabularCopySource {

    public static readonly READ_BEHAVIOR: IAttribute;

    @Metamodel.attribute({
        display: shellStringResources.ReadBehaviorLabel,
        association: 'READ_BEHAVIOR',
        templatable: true
    })
    public readBehavior: string = copySourceReadBehaviors.query;
}
